<template>
    <div id="app">
        <img src="./assets/mainlogo.png">
        <ul style="list-style-type:none">
            <li>Simplified Group Communication 👩‍👩‍👦‍👦</li>
            <li>Automated Reminders 🗓</li>
            <li>Peace of Mind 🧘‍</li>
        </ul>
        <div data-netlify-identity-button></div>
        <!--<div data-netlify-identity-button></div>-->
    </div>
</template>

<script>
    import Container from "bootstrap-vue/es/components/layout/container";

    export default {
        components: {Container},
        name: 'app',
        data () {
            return {
                fields: [ 'name', 'text_message', 'email', 'phone_call' ],
                items: [
                    {name: 'Jowanza Joseph', text_message: false},
                    {name: 'Ricks Davis'},
                    {name: 'Alexis Davis'},
                    {name: 'Bethany Joseph'}
                ],
                text: "Read chapter 3 of come follow me"
            }
        },
        mounted(){
            let script = document.createElement('script');
            script.setAttribute('src', 'https://identity.netlify.com/v1/netlify-identity-widget.js');
            script.async = true;
            document.head.appendChild(script);
        }
    }
</script>

<style lang="scss">
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        /*margin-top: 60px;*/
        background-image: linear-gradient(45deg,#9AD3DE,#93B8C0);
        height: 100vh;
    }

    h1, h2 {
        font-weight: bold;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        /*display: inline-block;*/
        margin: 0 10px;
        align-content: left;
        font-weight: bold;
    }

    a {
        color: black;
        font-weight: bold;
    }

</style>



// WEBPACK FOOTER //
// src/Landing.vue